export default {"src":"/_next/static/media/Adobe Connect.fc0bf4e4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};